<template>
  <div>
    <b-form @submit.prevent="submit">
      <b-row>
        <b-col cols="12">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.cooperation_date"
              :rules="$v.form.cooperationDate.$params"
            />
            <date-picker
              v-model="$v.form.cooperationDate.$model"
              type="date"
              :state="
                $v.form.cooperationDate.$dirty
                  ? !$v.form.cooperationDate.$error
                  : null
              "
              inputReq="true"
              clearable
              simple
              format="YYYY-MM-DD"
              display-format="jYYYY/jMM/jDD"
              :class="
                $v.form.cooperationDate.$dirty
                  ? $v.form.cooperationDate.$error
                    ? 'invalid-date'
                    : 'valid-date'
                  : null
              "
              :disabled="!!COOPERATION_DATE || mode === 'EDIT'"
              @input="getOrderCombo"
            >
            </date-picker>
            <b-form-invalid-feedback
              :state="
                $v.form.cooperationDate.$dirty
                  ? !$v.form.cooperationDate.$error
                  : null
              "
            >
              <div v-if="!$v.form.cooperationDate.required">
                {{ $lang.error_required | replace($lang.cooperation_date) }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.company_name"
              :rules="$v.form.companyName.$params"
            />
            <selectFind
              :options="companyNameOptions"
              v-model="$v.form.companyName.$model"
              label="caption"
              id="id"
              :loading="companyNameLoading"
              :isValid="
                $v.form.companyName.$dirty ? !$v.form.companyName.$error : null
              "
              :disabled="
                !!WORK_ORDER || !this.form.cooperationDate || mode === 'EDIT'
              "
            />
            <b-form-invalid-feedback
              :state="
                $v.form.companyName.$dirty ? !$v.form.companyName.$error : null
              "
            >
              {{ $lang.error_required | replace($lang.company_name) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.name_family"
              :rules="$v.form.parvandeh.$params"
              :showInfo="true"
              :titleText="$lang.daily_working_parvandeh_title_text"
            />
            <selectAsync
              :options="parvandehOptions"
              v-model="$v.form.parvandeh.$model"
              label="caption"
              id="id"
              :asyncFind="getParvandehCombo"
              :loading="parvandehLoading"
              :isValid="
                $v.form.parvandeh.$dirty ? !$v.form.parvandeh.$error : null
              "
              @input="getPaymentRuleCombo"
            />
            <b-form-invalid-feedback
              :state="
                $v.form.parvandeh.$dirty ? !$v.form.parvandeh.$error : null
              "
            >
              {{ $lang.error_required | replace($lang.name_family) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.payment_rule"
              :rules="$v.form.paymentRule.$params"
            />
            <selectFind
              :options="paymentRuleOptions"
              v-model="$v.form.paymentRule.$model"
              label="caption"
              id="id"
              :loading="paymentRuleLoading"
              :isValid="
                $v.form.paymentRule.$dirty ? !$v.form.paymentRule.$error : null
              "
            />
            <b-form-invalid-feedback
              :state="
                $v.form.paymentRule.$dirty ? !$v.form.paymentRule.$error : null
              "
            >
              {{ $lang.error_required | replace($lang.payment_rule) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.invitation_condition"
              :rules="$v.form.invitationCondition.$params"
            />
            <b-form-textarea
              type="text"
              v-model="$v.form.invitationCondition.$model"
              :rows="this.$config.form.textareaRows"
            >
            </b-form-textarea>
            <b-form-invalid-feedback
              :state="
                $v.form.invitationCondition.$dirty
                  ? !$v.form.invitationCondition.$error
                  : null
              "
            >
              <div v-if="!$v.form.invitationCondition.required">
                {{ $lang.error_required | replace($lang.invitation_condition) }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <!-- فیلد مکان برگزاری موقتا مخفی شده است -->
        <b-col cols="12" v-if="false">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.holding_location"
              :rules="$v.form.holdingLocation.$params"
            />
            <b-form-textarea
              type="text"
              v-model="$v.form.holdingLocation.$model"
              :rows="this.$config.form.textareaRows"
            >
            </b-form-textarea>
            <b-form-invalid-feedback
              :state="
                $v.form.holdingLocation.$dirty
                  ? !$v.form.holdingLocation.$error
                  : null
              "
            >
              <div v-if="!$v.form.holdingLocation.required">
                {{ $lang.error_required | replace($lang.holding_location) }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.position_in_project"
              :rules="$v.form.position.$params"
            />
            <b-form-input
              v-model="$v.form.position.$model"
              type="text"
              autocomplete="off"
              :state="$v.form.position.$dirty ? !$v.form.position.$error : null"
            />
            <b-form-invalid-feedback
              :state="$v.form.position.$dirty ? !$v.form.position.$error : null"
            >
              <div v-if="!$v.form.position.required">
                {{ $lang.error_required | replace($lang.position_in_project) }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col v-if="mode === 'EDIT'" cols="12" md="4">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.enter_time"
              :rules="$v.form.enterTime.$params"
            />
            <date-picker
              v-model="$v.form.enterTime.$model"
              type="time"
              :state="
                $v.form.enterTime.$dirty ? !$v.form.enterTime.$error : null
              "
              inputReq="true"
              clearable
              editable
              simple
              format="HH:mm"
              display-format="HH:mm"
              :class="
                $v.form.enterTime.$dirty
                  ? $v.form.enterTime.$error
                    ? 'invalid-date'
                    : 'valid-date'
                  : null
              "
            >
            </date-picker>
            <b-form-invalid-feedback
              :state="
                $v.form.enterTime.$dirty ? !$v.form.enterTime.$error : null
              "
            >
              <div v-if="!$v.form.enterTime.required">
                {{ $lang.error_required | replace($lang.enter_time) }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col v-if="mode === 'EDIT'" cols="12" md="4">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.exit_time"
              :rules="$v.form.exitTime.$params"
            />
            <date-picker
              v-model="$v.form.exitTime.$model"
              type="time"
              :state="$v.form.exitTime.$dirty ? !$v.form.exitTime.$error : null"
              inputReq="true"
              clearable
              editable
              simple
              format="HH:mm"
              display-format="HH:mm"
              :class="
                $v.form.exitTime.$dirty
                  ? $v.form.exitTime.$error
                    ? 'invalid-date'
                    : 'valid-date'
                  : null
              "
            >
            </date-picker>
            <b-form-invalid-feedback
              :state="$v.form.exitTime.$dirty ? !$v.form.exitTime.$error : null"
            >
              <div v-if="!$v.form.exitTime.required">
                {{ $lang.error_required | replace($lang.exit_time) }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col v-if="mode === 'EDIT'" cols="12" md="4">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.end_time"
              :rules="$v.form.endTime.$params"
            />
            <date-picker
              v-model="$v.form.endTime.$model"
              type="time"
              :state="$v.form.endTime.$dirty ? !$v.form.endTime.$error : null"
              inputReq="true"
              clearable
              editable
              simple
              format="HH:mm"
              display-format="HH:mm"
              :class="
                $v.form.endTime.$dirty
                  ? $v.form.endTime.$error
                    ? 'invalid-date'
                    : 'valid-date'
                  : null
              "
            >
            </date-picker>
            <b-form-invalid-feedback
              :state="$v.form.endTime.$dirty ? !$v.form.endTime.$error : null"
            >
              <div v-if="!$v.form.endTime.required">
                {{ $lang.error_required | replace($lang.end_time) }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col v-if="mode === 'EDIT'" cols="12" md="6">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.working_amount"
              :rules="$v.form.workingAmount.$params"
            />
            <b-form-input
              v-model="$v.form.workingAmount.$model"
              type="text"
              autocomplete="off"
              :state="
                $v.form.workingAmount.$dirty
                  ? !$v.form.workingAmount.$error
                  : null
              "
            />
            <b-form-invalid-feedback
              :state="
                $v.form.workingAmount.$dirty
                  ? !$v.form.workingAmount.$error
                  : null
              "
            >
              <div v-if="!$v.form.workingAmount.required">
                {{ $lang.error_required | replace($lang.working_amount) }}
              </div>
              <div v-if="!$v.form.workingAmount.numeric">
                {{ $lang.error_numeric | replace($lang.working_amount) }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col v-if="mode === 'EDIT'" cols="12" md="6">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.factor"
              :rules="$v.form.factor.$params"
            />
            <b-form-input
              v-model="$v.form.factor.$model"
              type="text"
              autocomplete="off"
              :state="$v.form.factor.$dirty ? !$v.form.factor.$error : null"
            />
            <b-form-invalid-feedback
              :state="$v.form.factor.$dirty ? !$v.form.factor.$error : null"
            >
              <div v-if="!$v.form.factor.required">
                {{ $lang.error_required | replace($lang.factor) }}
              </div>
              <div v-if="!$v.form.factor.numeric">
                {{ $lang.error_numeric | replace($lang.factor) }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col v-if="mode === 'EDIT'" cols="12">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="$lang.description"
              :rules="$v.form.description.$params"
            />
            <b-form-textarea
              type="text"
              v-model="$v.form.description.$model"
              :rows="this.$config.form.textareaRows"
            >
            </b-form-textarea>
            <b-form-invalid-feedback
              :state="
                $v.form.description.$dirty ? !$v.form.description.$error : null
              "
            >
              <div v-if="!$v.form.description.required">
                {{ $lang.error_required | replace($lang.description) }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" class="text-right mt-3">
          <b-button
            type="reset"
            class="mr-2"
            variant="outline-danger"
            @click="close"
          >
            <mdicon name="close" size="24" />
            {{ $lang.close }}
          </b-button>
          <b-button
            variant="success"
            @click="submit"
            v-if="isAdmin(PERMISSIONS) && !pathOr(false, ['selected'], item)"
          >
            <mdicon name="check" size="24" />
            {{ $lang.submitButton }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { required, numeric, requiredIf } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl, isAdmin, renderEumOptions } from "@/shared/utils";

export default {
  inject: ["PERMISSIONS", "COOPERATION_DATE", "WORK_ORDER"],
  components: { datePicker: VuePersianDatetimePicker },
  props: {
    mode: {
      type: String,
      default: "ADD",
    },
    item: {
      type: Object,
      default: null,
    },
  },
  validations: {
    form: {
      parvandeh: { required },
      companyName: { required },
      paymentRule: { required },
      invitationCondition: {},
      holdingLocation: {},
      cooperationDate: { required },
      position: {},
      enterTime: {},
      exitTime: {},
      endTime: {},
      description: {},
      workingAmount: {},
      factor: { required: requiredIf((vm) => vm.mode === "EDIT") },
    },
  },
  data() {
    return {
      parvandehLoading: false,
      parvandehOptions: [],
      companyNameLoading: false,
      companyNameOptions: [],
      paymentRuleLoading: false,
      paymentRuleOptions: [],

      form: {
        parvandeh: null,
        paymentRule: null,
        companyName: null,
        invitationCondition: null,
        holdingLocation: null,
        cooperationDate: null,
        position: null,
        enterTime: null,
        exitTime: null,
        endTime: null,
        description: null,
        workingAmount: null,
        factor: 1,
      },
    };
  },
  watch: {
    item: {
      immediate: true,
      handler(value) {
        value && this.fetchData();
      },
    },
    COOPERATION_DATE: {
      immediate: true,
      handler(value) {
        this.form.cooperationDate = pathOr(null, ["gregorian"], value);
      },
    },
    WORK_ORDER: {
      immediate: true,
      handler(value) {
        this.form.companyName = value
          ? this.generateWorkOrderItem(value)
          : null;
      },
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    isAdmin,
    renderEumOptions,
    close() {
      this.$emit("close");
    },
    generateParvandehItem(item, key = "code") {
      return {
        caption: `${pathOr("", ["parvandeh_number"], item)} - ${pathOr(
          "",
          ["person", "name"],
          item
        )} ${pathOr("", ["person", "family"], item)} - ${pathOr(
          "",
          ["term", "caption"],
          item
        )}`,
        id: pathOr(null, [key], item),
      };
    },
    generatePaymentRuleItem(item) {
      return {
        id: pathOr(null, ["id"], item),
        caption: `${pathOr("", ["rule_type", "caption"], item)} - ${pathOr(
          null,
          ["order_unit", "caption"],
          item
        )}`,
        is_default: pathOr(null, ["is_default"], item),
      };
    },
    generateWorkOrderItem(item) {
      const id = pathOr(null, ["id"], item);
      return {
        id,
        caption: `${pathOr("", ["id"], item)} - ${pathOr(
          "",
          ["company", "caption"],
          item
        )}`,
      };
    },
    async getParvandehCombo(query) {
      if (!query || query.length < 1) {
        return;
      }
      if (query.length > 1) {
        this.parvandehOptions = [];
      }

      try {
        this.parvandehLoading = true;
        const url = generateApiUrl(
          ["cooperation", "cooperation_parvandeh_combo"],
          [],
          {
            search_txt: query,
          }
        );
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.parvandehOptions = data.map((item) => {
          return this.generateParvandehItem(item, "parvandeh_code");
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.parvandehLoading = false;
      }
    },
    async getPaymentRuleCombo(item) {
      const parvandehCode = pathOr(null, ["id"], item);
      if (!parvandehCode) return;

      if (parvandehCode) {
        this.paymentRuleOptions = [];
        this.form.paymentRule = null;
      }

      try {
        this.paymentRuleLoading = true;
        const url = generateApiUrl(["cooperation", "payment_rule_combo"], [], {
          parvandeh_code: parvandehCode,
        });
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.paymentRuleOptions = data.map((item) => {
          return this.generatePaymentRuleItem(item);
        });
        this.form.paymentRule = this.paymentRuleOptions.find(
          (item) => item.is_default === 1
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.paymentRuleLoading = false;
      }
    },
    async getOrderCombo() {
      if (!this.form.cooperationDate) {
        return this.$notify.warning("لطفا تاریخ همکاری را تعیین نمایید.");
      }

      this.form.companyName = null;
      this.companyNameOptions = [];

      try {
        this.companyNameLoading = true;

        const url = generateApiUrl(["cooperation", "order_combo"], [], {
          order_execute_date: this.form.cooperationDate,
        });
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.companyNameOptions = data.map((item) =>
          this.generateWorkOrderItem(item)
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.companyNameLoading = false;
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      const payload = {
        parvandeh_code: pathOr(null, ["id"], this.form.parvandeh),
        payment_rule_id: pathOr(null, ["id"], this.form.paymentRule),
        work_order_id: pathOr(null, ["id"], this.form.companyName),
        invitation_condition: this.form.invitationCondition,
        holding_location: this.form.holdingLocation,
        cooperation_date: this.form.cooperationDate,
        position: this.form.position,
        enter_time: this.form.enterTime,
        exit_time: this.form.exitTime,
        end_time: this.form.endTime,
        description: this.form.description,
        working_amount: this.form.workingAmount,
        factor: this.form.factor,
      };
      this.$emit("submit", payload);
    },
    async fetchData() {
      this.form.cooperationDate = pathOr(
        null,
        ["cooperation_date", "gregorian"],
        this.item
      );
      this.form.companyName = this.generateWorkOrderItem(
        pathOr(null, ["work_order"], this.item)
      );
      const parvandeh = pathOr(null, ["parvandeh"], this.item);
      this.form.parvandeh = this.generateParvandehItem(parvandeh);
      await this.getPaymentRuleCombo({ id: pathOr(null, ["code"], parvandeh) });
      this.form.paymentRule = this.generatePaymentRuleItem(
        pathOr(null, ["payment_rule"], this.item)
      );
      this.form.invitationCondition = pathOr(
        null,
        ["invitation_condition"],
        this.item
      );
      this.form.holdingLocation = pathOr(null, ["holding_location"], this.item);
      this.form.position = pathOr(null, ["position"], this.item);
      this.form.enterTime = pathOr(null, ["enter_time"], this.item);
      this.form.exitTime = pathOr(null, ["exit_time"], this.item);
      this.form.endTime = pathOr(null, ["end_time"], this.item);
      this.form.workingAmount = pathOr(null, ["working_amount"], this.item);
      this.form.factor = pathOr(null, ["factor"], this.item);
      this.form.description = pathOr(null, ["description"], this.item);
    },
  },
};
</script>
